import Presentation from '../components/Presentation'

let routes = {
    path: '/presentation',
    name: 'Apresentação',
    component: Presentation
}

export default routes
